import { wrappingInputRule } from '@tiptap/core';
import OrderedList from '@tiptap/extension-ordered-list';

const ListItemName = 'listItem';
const TextStyleName = 'textStyle';

const inputRegex = /^(\d+)\.\s$/;

export default OrderedList.extend({
  addCommands() {
    return {
      toggleOrderedList:
        () =>
        ({ chain }) => {
          if (this.options.keepAttributes) {
            return chain()
              .toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
              .updateAttributes(ListItemName, {
                'data-list-type': 'numbered',
                ...this.editor.getAttributes(TextStyleName),
              })
              .run();
          }
          return chain()
            .toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
            .updateAttributes(ListItemName, { 'data-list-type': 'numbered' })
            .run();
        },
    };
  },
  addInputRules() {
    let inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type,
      getAttributes: (match) => ({ start: +match[1], 'data-list-type': 'numbered' }),
      joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
    });

    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: (match) => ({
          start: +match[1],
          'data-list-type': 'numbered',
          ...this.editor.getAttributes(TextStyleName),
        }),
        joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
        editor: this.editor,
      });
    }
    return [inputRule];
  },
});
